import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { commaFormatNumber } from '@Utils/String';
import AvailableRelativeContextsList from '../AvailableRelativeContextsList';
import { mapContextToTitle } from '../ResultToolbarConstants';

import './ContextsSwitcher.custom.scss';

function ContextsSwitcher(props) {
  const { activeBreadCrumbContext, totalResult } = props;

  return (
    <div>
      <h3 className="result-toolbar-context-switcher-title e2e-results-title">
        {commaFormatNumber(totalResult || '')}
        &nbsp;
        <span className="result-toolbar-context-switcher-title-current">{mapContextToTitle[activeBreadCrumbContext]}</span>
      </h3>

      <AvailableRelativeContextsList {...props} />
    </div>
  );
}

ContextsSwitcher.propTypes = {
  activeBreadCrumbContext: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  totalResult: PropTypes.number,
};

export default memo(ContextsSwitcher);
